import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import FormCheckboxField from '@adv-mt/mt-form-checkbox-field'

const LEGACY_WRAPPER = 'legacy'
const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormHasPhoto = ({id, value, onChange, type, wrapper = LEGACY_WRAPPER}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    setTimeout(
      () =>
        onChange(e, {
          field: FILTER_NAMES.HAS_PHOTO,
          value: checked,
          lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_PHOTO]
        }),
      0
    )
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    _handleOnChange(null, {checked: currentValue === CHECKED_ID})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <FormCheckboxField
        checked={value}
        id={id || FILTER_NAMES.HAS_PHOTO}
        label={i18n.t('FORM.ONLY_WITH_PHOTO')}
        onChange={_handleOnChange}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('FORM.ONLY_WITH_PHOTO'),
          name: FILTER_NAMES.HAS_PHOTO,
          options: [{id: CHECKED_ID, label: i18n.t('FORM.ONLY_WITH_PHOTO')}],
          type
        }
      ]}
      group={`${FILTER_NAMES.HAS_PHOTO}Group`}
      legend={i18n.t('FORM.ONLY_WITH_PHOTO')}
      onChange={handleChecked}
      value={{[FILTER_NAMES.HAS_PHOTO]: [value ? [CHECKED_ID] : [UNCHECKED_ID]]}}
      wrapper={wrapper}
    />
  )
}

FormHasPhoto.displayName = 'FormHasPhoto'
FormHasPhoto.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wrapper: PropTypes.string
}

export default FormHasPhoto
